/**
 * Central video registry, paste your hosted MP4/YouTube/Vimeo URL here.
 *
 * After you render the Synthesia pitch deck:
 *   1. Host the MP4 (Cloudflare R2 / YouTube unlisted / Vimeo)
 *   2. Paste the URL into `videoUrl` below
 *   3. (Optional) Add a poster image URL, shown before play
 *   4. Save, site updates automatically
 *
 * Supports:
 *   - MP4 / WebM direct links  → e.g. https://pub-xxx.r2.dev/.../intro.mp4
 *   - YouTube                  → e.g. https://www.youtube.com/watch?v=ABC123
 *   - Vimeo                    → e.g. https://vimeo.com/123456789
 *
 * If `videoUrl` is null the page shows the script-and-timeline placeholder,
 * so the site never breaks while the video is being produced.
 */
export const introVideo = {
  videoUrl: 'https://customer-assets.emergentagent.com/job_videra-platform/artifacts/6qniqbut_Keystone%20%26%20Videra%20Introduction.mp4',
  posterUrl: null,
};

/**
 * Sector-specific intro videos (Construction+, NHS, Hard Services etc.)
 * Used on the sector detail pages.
 */
export const sectorVideos = {
  'construction':   { videoUrl: 'https://pub-538a284ae38c42ab950edc755f39a2db.r2.dev/videravids/videra-construction-plus.mp4', posterUrl: null }, // Construction+ intro
  'nhs':            { videoUrl: null, posterUrl: null }, // NHS Estates Portfolio intro
  'hard-services':  { videoUrl: null, posterUrl: null }, // Videra Healthcare intro
};
